(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fade-slider-popup"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const section = document.currentScript && document.currentScript.closest('.kb-fade-slider-section') || document.querySelector('.kb-fade-slider-section');
    if(!section) return;

    const inner = section.querySelector('.kb-fade-slider__inner');
    const slider = section.querySelectorAll('.kb-fade-slide');
    const toggleBtn = section.querySelector('.kb-fade-slider__toggle-slider');
    const popup = section.querySelector('.kb-fade-popup');
    const openPopupBtn = section.querySelector('.kb-fade-slider__open-popup');
    const closePopupBtn = section.querySelector('.kb-fade-popup__close');
    const overlay = section.querySelector('.kb-fade-popup__overlay');
    let autoplay = section.querySelector('.kb-fade-slider__slider')?.dataset.autoplay === 'true';
    let current = 0; let intervalId=null;

    function showSection(){ section.classList.add('kb-visible'); }
    function setActive(idx){ slider.forEach((s,i)=> s.classList.toggle('is-active', i===idx)); }

    function next(){ current = (current+1)%slider.length; setActive(current); }
    function startAutoplay(){ if(!autoplay|| intervalId) return; intervalId=setInterval(next,4000); }
    function stopAutoplay(){ if(!intervalId) return; clearInterval(intervalId); intervalId=null; }

    // fade-in on intersection
    const io = new IntersectionObserver(entries=>{ entries.forEach(e=>{ if(e.isIntersecting) showSection(); }); },{threshold:0.15});
    io.observe(section);

    if(slider.length) setActive(0);
    if(autoplay) startAutoplay();

    toggleBtn.addEventListener('click', ()=>{
      const pressed = toggleBtn.getAttribute('aria-pressed') === 'true';
      toggleBtn.setAttribute('aria-pressed', String(!pressed));
      if(pressed) startAutoplay(); else stopAutoplay();
      toggleBtn.textContent = pressed ? 'Start slider' : 'Stop slider';
    });

    // Popup behavior
    function openPopup(){ popup.setAttribute('aria-hidden','false'); popup.querySelector('.kb-fade-popup__panel').focus(); document.body.style.overflow='hidden'; }
    function closePopup(){ popup.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    openPopupBtn.addEventListener('click', openPopup);
    closePopupBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);

    // ESC to close
    document.addEventListener('keydown', (e)=>{ if(e.key==='Escape' && popup.getAttribute('aria-hidden')==='false') closePopup(); });

    // simple form submit handler
    const form = section.querySelector('.kb-fade-popup__form');
    form.addEventListener('submit', function(e){ e.preventDefault(); const data = new FormData(form); fetch('/?contact%5B%5D=1',{method:'POST',body:data}).then(()=>{ closePopup(); alert('Grazie!'); }).catch(()=>{ alert('Errore invio'); }); });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initShopTheLook(sectionEl) {
    var pinWraps = sectionEl.querySelectorAll('.stl-pin-wrap');
    if (!pinWraps.length) return;

    function closeAll() {
      pinWraps.forEach(function (wrap) {
        if (wrap.classList.contains('is-open')) {
          wrap.classList.remove('is-open');
          var btn = wrap.querySelector('.stl-pin');
          var pop = wrap.querySelector('.stl-popover');
          if (btn) btn.setAttribute('aria-expanded', 'false');
          if (pop) pop.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function openPin(wrap) {
      closeAll();
      wrap.classList.add('is-open');
      var btn = wrap.querySelector('.stl-pin');
      var pop = wrap.querySelector('.stl-popover');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (pop) pop.setAttribute('aria-hidden', 'false');
    }

    function adjustPopoverEdge(wrap) {
      var rect = wrap.getBoundingClientRect();
      var heroRect = sectionEl.getBoundingClientRect();
      wrap.classList.remove('stl-pop-down', 'stl-pop-right');

      if (rect.top - heroRect.top < 200) {
        wrap.classList.add('stl-pop-down');
      }
    }

    pinWraps.forEach(function (wrap) {
      var btn = wrap.querySelector('.stl-pin');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = wrap.classList.contains('is-open');
        if (isOpen) {
          closeAll();
        } else {
          adjustPopoverEdge(wrap);
          openPin(wrap);
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!sectionEl.contains(e.target)) {
        closeAll();
        return;
      }
      var clickedWrap = e.target.closest('.stl-pin-wrap');
      if (!clickedWrap) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  function boot() {
    var sections = document.querySelectorAll('.stl-section');
    sections.forEach(function (s) { initShopTheLook(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.stl-section');
      if (s) initShopTheLook(s);
    });
  }
}());

  } catch(e) { console.error(e); }
})();
})();
